import { Font } from "@react-pdf/renderer";
import RobotoRegular from "./Roboto-Regular.ttf";

// ✅ Registrace fontu pro použití v react-pdf
Font.register({
    family: "Roboto",
    src: RobotoRegular,
});
